import React, {
  memo,
  useMemo,
} from 'react';

import {
  useTQConnectServiceRequestResponses,
} from '../../../../hooks/queries/tqConnectQueries/service-requests';
import { useAppNavigate } from '../../../../shared/hooks';
import { ROUTES } from '../../../../types/routes';
import {
  ITQServiceRequestResponse,
} from '../../../../types/tqConnectTypes/service-requests';
import MyResponse from './MyResponse';
import ResponsesList from './ResponsesList';

interface Props {
  isMyRequest: boolean;
  serviceRequestId: string;
  onViewResponse: (response: ITQServiceRequestResponse) => void;
}

const ServiceRequestResponses: React.FC<Props> = ({
  isMyRequest,
  serviceRequestId,
  onViewResponse,
}) => {
  const navigate = useAppNavigate();
  // const dispatch = useAppDispatch();
  const {
    data: serviceRequestResponsesResult,
    isLoading: loading,
    hasNextPage: hasMore,
    fetchNextPage,
    isFetchingNextPage,
  } = useTQConnectServiceRequestResponses(serviceRequestId);

  const { list, total, myResponse } = useMemo(() => {
    return {
      list: serviceRequestResponsesResult?.data ?? [],
      total: serviceRequestResponsesResult?.total ?? 0,
      myResponse: serviceRequestResponsesResult?.myResponse,
    };
  }, [
    serviceRequestResponsesResult?.data,
    serviceRequestResponsesResult?.total,
    serviceRequestResponsesResult?.myResponse,
  ]);

  const loadMore = () => {
    if (hasMore && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const handleViewResponse = (response: ITQServiceRequestResponse) => {
    if (isMyRequest) {
      navigate(
        ROUTES.TQ_CONNECT_SERVICE_REQUESTS_RESPONSE_DETAILS,
        {
          serviceRequestId,
        },
        {
          search: `responseId=${response._id}`,
        },
      );
    } else {
      onViewResponse(response);
    }
  };

  return (
    <div
      className="service-request-responses"
      id={`service-request-responses-${serviceRequestId}`}>
      {myResponse && (
        <MyResponse
          myResponse={myResponse}
          onViewResponse={() => {
            handleViewResponse(myResponse);
          }}
        />
      )}

      <ResponsesList
        serviceRequestId={serviceRequestId}
        isMyRequest={isMyRequest}
        hasMyResponse={!!myResponse}
        list={list}
        total={total}
        loading={loading}
        isFetchingNextPage={isFetchingNextPage}
        hasMore={hasMore}
        onLoadMore={loadMore}
        onViewResponse={handleViewResponse}
      />
    </div>
  );
};

export default memo(ServiceRequestResponses);
